// components/form/schemas/oneOne.js
const twoTwoSchema = {
  title: "2_2 Imported Energy",
  addAPI: "cat2_2AddEmissionActivityAPI",
  cat: "cat2_2",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Energy Supplier or Region",
      resetOnChange: false,
      required: true,
    },
    {
      key: "activityId",
      level: 1,
      type: "select",
      label: "Energy Type",
      optionsAPI: "importedEnergyEnergyTypeAPI",
      required: true,
      resetOnChange: true,
    },
  ],
};

export default twoTwoSchema;
